import type { NuxtLinkProps } from "#app";
import { PRODUCT_ROUTE } from "~/pages/produktkatalog/[slug].vue";
import { PRODUCT_CATALOGUE_ROUTE } from "~/pages/produktkatalog/index.vue";

/**
 * Resolves links in article CTAs to the current product slugs.
 *
 * A bit nasty, since we have hardcoded checks by product name, but it's the best we can do without changing the Crystallize shapes.
 */
export function useCtaLinks() {
  const { data } = useProducts("/aunivers");

  type LinkConfig = Record<CtaLink, {
    to: NuxtLinkProps["to"];
    label: string;
  }>;

  return computed<LinkConfig>(() => {
    const results = {
      "modus": {
        to: {
          name: PRODUCT_ROUTE,
          params: { slug: "modus" },
        },
        label: "Les mer om Modus",
      },
      "aunivers-barneskole": {
        to: {
          name: PRODUCT_ROUTE,
          params: { slug: "aunivers-barneskole" },
        },
        label: "Les mer om Aschehoug Univers for barneskole",
      },
      "aunivers-ungdomsskole": {
        to: {
          name: PRODUCT_ROUTE,
          params: { slug: "aunivers-ungdomsskole" },
        },
        label: "Les mer om Aschehoug Univers for ungdomsskole",
      },
      "digitalt-supplement": {
        to: {
          name: PRODUCT_ROUTE,
          params: { slug: "aunivers-vgs" },
        },
        label: "Les mer om Digitalt supplement for VGS",
      },
      "produktkatalog": {
        to: { name: PRODUCT_CATALOGUE_ROUTE },
        label: "Se produktkatalogen",
      },
    } satisfies LinkConfig;

    const products = data.value ?? [];
    for (const product of products) {
      if (!isPacket(product))
        continue;

      if (product.name?.toLowerCase().includes("modus")) {
        results.modus.to.params.slug = product.slug.short;
      } else if (product.name?.toLowerCase().includes("vgs")) {
        results["digitalt-supplement"].to.params.slug = product.slug.short;
      } else if (product.name?.toLowerCase().includes("univers")) {
        if (product.levels?.includes("1-7")) {
          results["aunivers-barneskole"].to.params.slug = product.slug.short;
        } else if (product.levels?.includes("8-10")) {
          results["aunivers-ungdomsskole"].to.params.slug = product.slug.short;
        }
      }
    }

    return results;
  });
}
